import { render, staticRenderFns } from "./LPDataTableTbody.vue?vue&type=template&id=581686d2&scoped=true&"
import script from "./LPDataTableTbody.vue?vue&type=script&lang=js&"
export * from "./LPDataTableTbody.vue?vue&type=script&lang=js&"
import style0 from "./LPDataTableTbody.vue?vue&type=style&index=0&id=581686d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581686d2",
  null
  
)

export default component.exports